import React, { useEffect } from "react";
import { Modal, Form, InputNumber, Select, DatePicker, Input, Row, Col } from "antd";
import dayjs from "dayjs";
import ContactInput from "../../../components/ContactInput";

const { Option } = Select;

function AffiliateUpdateModal({ editingAffiliate, isModalVisible, setIsModalVisible, loading, handleSubmit, title = "Update Affiliate" }) {
  const [form] = Form.useForm();
  const isApproving = editingAffiliate?.status === "APPROVED";
  const isNewAffiliate = !editingAffiliate;

  useEffect(() => {
    if (editingAffiliate) {
      const formattedValues = {
        ...editingAffiliate,
        dob: editingAffiliate.dob ? dayjs(editingAffiliate.dob) : null,
      };
      form.setFieldsValue(formattedValues);
    } else {
      form.resetFields();
    }
  }, [editingAffiliate, form]);

  const onOk = async () => {
    try {
      const values = await form.validateFields();
      const formattedValues = {
        ...values,
      };
      await handleSubmit(formattedValues);
      // form.resetFields();
    } catch (error) {
      console.error('Form validation failed:', error);
    }
  };

  return (
    <Modal
      title={title}
      open={isModalVisible}
      onOk={onOk}
      onCancel={() => {
        form.resetFields();
        setIsModalVisible(false);
      }}
      confirmLoading={loading}
      width={700}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={{
          commissionType: "percentage",
          status: "PENDING",
        }}
        style={{ maxWidth: "100%" }}
      >
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '16px' }}>
          {isNewAffiliate && (
            <>
              <Form.Item
                name="fullName"
                label="Full Name"
                rules={[{ required: true, message: 'Please enter full name!' }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Enter full name" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  { required: true, message: 'Please enter email!' },
                  { type: 'email', message: 'Please enter a valid email!' }
                ]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Enter email" />
              </Form.Item>
              <Form.Item
                name="phoneNumber"
                label="Phone Number"
                rules={[
                  { required: true, message: 'Please enter phone number!' },
                  {
                    validator(_, value) {
                      if (value && !/^\+?[1-9]\d{1,14}$/.test(value)) {
                        return Promise.reject(new Error('Please enter a valid phone number'));
                      }
                      return Promise.resolve();
                    },
                  },
                ]}
                
                style={{ marginBottom: 0 }}
              >
                <ContactInput />
              </Form.Item>
              <Form.Item
                name="password"
                label="Password"
                rules={[
                  { required: true, message: 'Please enter password!' },
                  { min: 6, message: 'Password must be at least 6 characters!' }
                ]}
                hasFeedback
                style={{ marginBottom: 0 }}
              >
                <Input.Password placeholder="Enter password" />
              </Form.Item>
              {/* <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                dependencies={['password']}
                hasFeedback
                rules={[
                  { required: true, message: 'Please confirm your password!' },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value || getFieldValue('password') === value) {
                        return Promise.resolve();
                      }
                      return Promise.reject(new Error('The two passwords do not match!'));
                    },
                  }),
                ]}
                style={{ marginBottom: 0 }}
              >
                <Input.Password placeholder="Confirm password" />
              </Form.Item> */}
              <Form.Item
                name="dob"
                label="Date of Birth"
                rules={[{ required: true, message: 'Please select date of birth!' }]}
                getValueProps={(value) => ({
                  value: value ? dayjs(value) : null
                })}
                style={{ marginBottom: 0 }}
              >
                <DatePicker 
                  style={{ width: '100%' }} 
                  format="YYYY-MM-DD"
                  disabledDate={(current) => {
                    return current && current > dayjs().endOf('day');
                  }}
                />
              </Form.Item>
              <Form.Item
                name="city"
                label="City"
                rules={[{ required: true, message: 'Please enter city!' }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Enter city" />
              </Form.Item>
              <Form.Item
                name="state"
                label="State/Province"
                rules={[{ required: true, message: 'Please enter state/province!' }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Enter state/province" />
              </Form.Item>
              <Form.Item
                name="country"
                label="Country"
                rules={[{ required: true, message: 'Please enter country!' }]}
                style={{ marginBottom: 0 }}
              >
                <Input placeholder="Enter country" />
              </Form.Item>
            </>
          )}
          
          <Form.Item 
            name="status" 
            label="Status" 
            rules={[{ required: true, message: "Please select status!" }]} 
            hidden={isApproving || isNewAffiliate}
            style={{ marginBottom: 0 }}
          >
            <Select style={{ width: "100%" }}>
              <Option value="PENDING">Pending</Option>
              <Option value="APPROVED">Approved</Option>
              <Option value="REJECTED">Rejected</Option>
            </Select>
          </Form.Item>
          
          {isApproving && !isNewAffiliate && (
            <Form.Item label="Status" style={{ margin: 0 }}>
              <div style={{ padding: '4px 11px', border: '1px solid #d9d9d9', borderRadius: '6px', background: '#f5f5f5' }}>
                Approved
              </div>
              <input type="hidden" name="status" value="APPROVED" />
            </Form.Item>
          )}
          
          <Form.Item 
            name="commissionType" 
            label="Commission Type" 
            rules={[{ required: true, message: "Please select commission type!" }]} 
            style={{ marginBottom: 0 }}
          >
            <Select style={{ width: "100%" }}>
              <Option value="percentage">Percentage</Option>
              <Option value="fixed">Fixed Amount</Option>
            </Select>
          </Form.Item>
          
          <Form.Item
            name="commissionValue"
            label="Commission Value"
            rules={[{ required: true, message: "Please enter commission value!" }]}
            style={{ marginBottom: 0 }}
          >
            <InputNumber min={0} style={{ width: "100%" }} />
          </Form.Item>
        </div>
      </Form>
    </Modal>
  );
}

export default AffiliateUpdateModal;
